import { useState, useRef } from "react";
import NewTrainerHeaderItemV2 from "./NewTrainerHeaderItemV2";
import { ErrorTemplate } from "../../common/ToastMessage/Template";
import { Toast } from "primereact/toast";
const NewTrainerItemV2 = ({
  source,
  onViewMoreClick,
  props,
  onFavoriteClick,
  activeTooltipId,
  onItemHover,
  currentUser,
  lang
}) => {
  const isTooltipVisible = activeTooltipId === source.id;
  
  const buyTicket = (bundleDiscount) => {
    if (currentUser) {
      const query = new URLSearchParams({
            isQuickBuy: true,
            productId: source.productId,
            bundleDiscount: bundleDiscount.id,
            quantity: bundleDiscount.numberTicket
          }).toString();
      window.location.href = `/${currentUser.defaultLanguage}/shopping-cart?${query}`;
    } else {
      window.location.href = `/auth/login?lang=${lang}&returnUrl=${window.location.pathname}`;
    }
  };

  const errorToast = useRef(null);
  const showErrorToast = (message) => {
    errorToast.current.show({ 
      severity: "error", 
      detail: message,
      life: 3000, 
      content: (props) => ErrorTemplate(props)
    });
  };

  return (
    <div
      className="flex flex-row flex-nowrap gap-4 w-full h-full"
      onMouseEnter={() => onItemHover && onItemHover(source.id)}
      onMouseLeave={() => onItemHover && onItemHover(null)}
    >
      <Toast ref={errorToast} position="bottom-right" className="keduall-toast"/>
      <div
        className="keduall-trainer-item flex flex-column gap-4 p-2 flex-1 min-w-0 justify-content-center align-items-center"
      >
        <NewTrainerHeaderItemV2
          props={props}
          onViewMoreClick={onViewMoreClick}
          onFavoriteClick={onFavoriteClick}
          source={source}
          enableTagsCollapse={false}
          maximumTagItem={3}
          lang={lang}
        ></NewTrainerHeaderItemV2>
      </div>
    </div>
  );
};

export default NewTrainerItemV2;